document.addEventListener('DOMContentLoaded', function() {
  /*var bodyHasTemplateCart = document.body.classList.contains('template-cart');

  if (bodyHasTemplateCart) {
    var cvCartHeaderLink = document.querySelector('.cv_cart_header a');
    
    if (cvCartHeaderLink) {
      cvCartHeaderLink.click();
    }
  }*/
  if(document.querySelectorAll(`.cv_choosepro`).length > 0){
    document.querySelectorAll(`.cv_choosepro input.cv_bundle_pro[name="bundle"]`).forEach( (el) => {
    	el.addEventListener("change",function(event){
    		const currentElement = event.target.parentElement.parentElement.parentElement;
    		document.querySelectorAll(`.cv_choosepro`).forEach((e)=>{
    			e.classList.remove("active");
    		});
    		currentElement.classList.add("active");
    	});	
    });
  }
  
});
/*jQuery(document).ready(function($){
  $(document).on("change",`.cv_choosepro input.cv_bundle_pro[name="bundle"]`,function(){
     $(".cv_choosepro").removeClass("active");
    $(this).parents(".cv_choosepro").addClass("active");
  });
});*/

$(document).ready(function () {
  new Swiper('.swiper-container', {
                        // Optional parameters
                        direction: 'horizontal',
                        spaceBetween: 16,
                        slidesPerView: 4,
                        roundLengths: true,
                        loop: true,
                        pagination: {
                            el: '.slider__pagination',
                            clickable: true,
                        },
                        navigation: {
                            nextEl: '.swiper-button-next',
                            prevEl: '.swiper-button-prev',
                        },
                        breakpoints: {
                            1200: {
                                slidesPerView: 3, // Use 1 for a single slide, adjust as needed
                            },
                            990: {
                                centeredSlides: true,
                                slidesPerView: 2.2, // Use 1 for a single slide, adjust as needed
                            },
                            700: {
                                centeredSlides: true,
                                slidesPerView: 1.2, // Use 1 for a single slide, adjust as needed
                            },
                        },
                    })
  var this_val, pro_title;
  /*$(".cv_choosepro").each(function () {
    $(this)
      .find('input.cv_bundle_pro[name="bundle"]')
      .change(function () {
        //    console.log('change');
        $(".cv_choosepro").removeClass("active");
        if ($(this).is(":checked")) {
          $(this).parents("label").parent(".cv_choosepro").addClass("active");
        }
      });
  });*/
  $(".cv_sec_third").each(function () {
    $(".cv_seloptions_with_heading", this).each(function (index) {
      var $thisSelect = $(this).find("select");
      if (index) {
        var arr = [];
        $(".sec_bundle_drop .cv_seloptions_with_heading").each(function (
          secindex
        ) {
          if (index > secindex) {
            arr.push($(this).find("select option:selected").val());
          }
        });
        $thisSelect.find("option").each(function (optionIndex) {
          var $thisOption = $(this);
          if (arr.indexOf($thisOption.val()) == -1) {
            $thisOption.prop("selected", true);
          }
        });
      }
    });
  });
  var lenght = $('.cv_selectbox_bundle option[value="' + pro_title + '"]').attr(
    "selected",
    "selected"
  ).length;
  $(document).on("click", ".cv_addtocart", function (e) {
    e.preventDefault();
    var arrayTags = [];
    var varID = $('[name="bundle"]:checked').val();
    var default_var = $(".Cv_Default_Selector option:selected").val();
    var checked_val;
    if (
      $('input[name="bundle"]:checked')
        .parents(".cv_choosepro")
        .find(".bundle_drop_down").length
    ) {
      var data_property = $('input[name="bundle"]:checked')
        .parents(".cv_choosepro")
        .find(".bundle_drop_down")
        .attr("data-property");
      $('[name="bundle"]:checked')
        .parents(".cv_choosepro")
        .find(".bundle_drop_down")
        .find(".cv_selectbox_bundle option:selected")
        .each(function () {
          debugger;
          checked_val = $(this).val();
          arrayTags.push(checked_val);
        });
      if (varID == 39253402648611) {
        arrayTags = arrayTags.toString();
        arrayTags = arrayTags.replace(/,/g, "-");
        arrayTags = arrayTags.replace(/^(.+?-.+?)-\s*/g, "$1,");
      }
      var data =
        '{"id": "' +
        varID +
        '", "quantity" : ' +
        1 +
        ', "properties": {"Choix": "' +
        arrayTags.toString() +
        '"}}';
      $.ajax({
        url: "/cart/add.js",
        type: "POST",
        dataType: "json",
        data: JSON.parse(data),
        success: function (response) {
          $.ajax({
            type: "GET",
            url: "/cart",
            dataType: "html",
            success: function (response) {
              $("#cartForm").load(" #cartForm");
              $(".cvv_header_cart_outer").html(
                $(response).find(".cvv_header_cart_outer").html()
              );
              $(".cart_drawer")
                .html($(response).filter(".cart_drawer").html())
                .addClass("cart_drawer_open");
              $("body").addClass("drawer_open");
              updateProgessbar();
              loadProductRecommendationsIntoSectionCart();
              setTimeout(function () {
                var fiveMinutes = 60 * 10,
                  display = document.querySelector("#time");
                clearInterval(existingIntervalId);
                startTimer(fiveMinutes, display);
              }, 1000);
            },
          });
        },
      });
    } else {
      if (varID === "33043547848739") {
        default_var = varID;
      }
      $.ajax({
        url: "/cart/add.js",
        type: "POST",
        dataType: "JSON",
        data: {
          id: default_var,
          quantity: 1,
        },
        success: function (response) {
          $.ajax({
            type: "GET",
            url: "/cart",
            dataType: "html",
            success: function (response) {
              $("#cartForm").load(" #cartForm");
              $(".cvv_header_cart_outer").html(
                $(response).find(".cvv_header_cart_outer").html()
              );
              $(".cart_drawer")
                .html($(response).filter(".cart_drawer").html())
                .addClass("cart_drawer_open");
              $("body").addClass("drawer_open");
              updateProgessbar();
              loadProductRecommendationsIntoSectionCart();
              setTimeout(function () {
                var fiveMinutes = 60 * 10,
                  display = document.querySelector("#time");
                clearInterval(existingIntervalId);
                startTimer(fiveMinutes, display);
              }, 1000);
            },
          });
        },
      });
    }
  });

  $(document).on("click touchstart", ".cv_upsell_cart", function (e) {
    var upsellID = $(this).attr("upsellId");
    $.ajax({
      url: "/cart/add.js",
      type: "POST",
      dataType: "JSON",
      data: {
        id: upsellID,
        quantity: 1,
      },
      success: function (response) {
        $.ajax({
          type: "GET",
          url: "/cart",
          dataType: "html",
          success: function (response) {
            $("#cartForm").load(" #cartForm");
            $(".cvv_header_cart_outer").html(
              $(response).find(".cvv_header_cart_outer").html()
            );
            $(".cart_drawer")
              .html($(response).filter(".cart_drawer").html())
              .addClass("cart_drawer_open");
            $("body").addClass("drawer_open");
            updateProgessbar();
            loadProductRecommendationsIntoSectionCart();
            setTimeout(function () {
              var fiveMinutes = 60 * 10,
                display = document.querySelector("#time");
              clearInterval(existingIntervalId);
              startTimer(fiveMinutes, display);
            }, 1000);
          },
        });
      },
    });
  });

  //   cart drawer remove code start here
  $(document).on("click touchstart", ".cart__remove", function (e) {
    e.preventDefault();
    var url = $(this).attr("href");
     hideCartActionButtons();
    $.ajax({
      url: url,
      type: "GET",
      success: function (response) {
       /*let get_total = parseInt($(response).find(".subtotal_price").attr('data-total'));
        if(get_total <= 0){
          document.querySelectorAll('[name="checkout"]').forEach(elem => {
          elem.disabled = true;
        });
        }else{
          document.querySelectorAll('[name="checkout"]').forEach(elem => {
            elem.disabled = false;
          });
        }*/
       
        $(".cvv_header_cart_outer").html(
          $(response).find(".cvv_header_cart_outer").html()
        );
        $(".cart_drawer")
          .html($(response).filter(".cart_drawer").html())
          .addClass("cart_drawer_open");
        $("body").addClass("drawer_open");
        updateProgessbar();
        loadProductRecommendationsIntoSectionCart();
        setTimeout(function () {
          var fiveMinutes = 60 * 10,
            display = document.querySelector("#time");
          clearInterval(existingIntervalId);
          startTimer(fiveMinutes, display);
        }, 1000);
      },
    });
  });
  // cart drawer remove code end here
  //   cart drawer open on click on cart icon code start here
  $(document).on("click touchend", ".cvv_header_cart_outer", function (e) {
    e.preventDefault();
    $(".cart_drawer").addClass("cart_drawer_open");
    $("body").addClass("drawer_open");
    setTimeout(function () {
      var fiveMinutes = 60 * 10,
        display = document.querySelector("#time");

      if (window.startTimer) {
        if (window.existingIntervalId) {
          clearInterval(window.existingIntervalId);
        }
        window.startTimer(fiveMinutes, display);
      }
    }, 1000);
    updateProgessbar();
    loadProductRecommendationsIntoSectionCart();
  });
  // cart drawer opem on click on cart icon code end here
  //cart drawer close start here
  $(document).on("click touchstart", ".cv_cart_close", function (e) {
    e.preventDefault();
    $(".cart_drawer").removeClass("cart_drawer_open");
    $("body").removeClass("drawer_open");
  });
  $(document).on(
    "click touchstart",
    ".Cv_close_cart_darwer_btn span",
    function (e) {
      e.preventDefault();
      $(".cart_drawer").removeClass("cart_drawer_open");
      $("body").removeClass("drawer_open");
    }
  );
  $(document).click(function (e) {
    if (!$(e.target).closest(".cart_drawer, .cv_cart_header").length) {
      $(".cart_drawer").removeClass("cart_drawer_open");
      $("body").removeClass("drawer_open");
    }
  });
  //   cart drawer close end here
  //   cart drawer quantity box code start here
  function updateQuantity(line, quantity) {
     hideCartActionButtons();
    $.ajax({
      type: "POST",
      url: "/cart/change",
      data: "quantity=" + quantity + "&line=" + line,
      dataType: "json",
      success: function (cart) {
        /*let cartTotalinCent = cart.total_price;
        if(cartTotalinCent <= 0){
    document.querySelectorAll('[name="checkout"]').forEach(elem => {
  elem.disabled = true;
});
  }else{
    document.querySelectorAll('[name="checkout"]').forEach(elem => {
  elem.disabled = false;
});
  }*/
        $(".subtotal_price").html(
          '<span class="theme-money">' +
            slate.Currency.formatMoney(cart.total_price, theme.moneyFormat) +
            "</span>"
        );
        updateProgessbar();
        setTimeout(function () {
          var fiveMinutes = 60 * 10,
            display = document.querySelector("#time");
          clearInterval(existingIntervalId);
          startTimer(fiveMinutes, display);
        }, 1000);
      },
    });
  }
  $(document).on("click", ".add", function (e) {
    e.preventDefault();
    $(this)
      .prev()
      .val(+$(this).prev().val() + 1);
    var line = $(this).attr("data-line");
    var quantity = $(this).prev().val();
    updateQuantity(line, quantity);
  });
  $(document).on("click", ".sub", function (e) {
    e.preventDefault();
    if ($(this).next().val() > 1) {
      if ($(this).next().val() > 1)
        $(this)
          .next()
          .val(+$(this).next().val() - 1);
      var line = $(this).attr("data-line");
      var quantity = $(this).next().val();
      updateQuantity(line, quantity);
    }
  });
  // cart drawer quantity box code end here
  // productpage accordian code start here
  var acc = document.getElementsByClassName("accordion");
  var i;
  for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function () {
      this.classList.toggle("active");
      var panel = this.nextElementSibling;
      if (panel.style.display === "block") {
        panel.style.display = "none";
      } else {
        panel.style.display = "block";
      }
    });
  }
  // product page accordian code end here
});
// mobile fixed header code start here
if ($(window).width() <= 700) {
  $(window).scroll(function () {
    var sticky = $(".cv_header_outer"),
      scroll = $(window).scrollTop();

    if (scroll >= 100) sticky.addClass("fixed");
    else sticky.removeClass("fixed");
  });
}
// mobile fixed header code end here

//floating addtocart script start  here

$(document).on("touchstart", ".floating_addtocart_button", function () {
  $(
    ".form-row.input-row--full-width.product-form-button-container button.btn.cv_addtocart.btn--primary"
  ).trigger("click");
});
// floating addtocart script end here


$(document).ready(function () {
//if(document.body.classList.contains('new-cart')) {
  
  $(".cv-swatch").change(function () {
    var idd = $("option:selected", this).attr("data-attr");
    $(".cv_fisrt_product_block.cv_choosepro input.cv_bundle_pro").val(idd);
  });

  $(document).on("change", ".eg-option-select-patch", function () {
    var id = $(this).val();
    var parent = $(this).closest(".eg-crossSell_item");
    var atc = parent.find(".eg-crossSell_add-item");
    atc.attr("data-id", id);
  });
  $(document).on("click", ".eg-crossSell_add-item", function () {
    var upsellID = $(this).attr("data-id");
    addToCart(upsellID);
  });

//}
});

//if(document.body.classList.contains('new-cart')) {

const checkGiftAdded = async function (items, id) {
  const matched = items.filter((item) => item.id == id);
  if (matched.length > 0) {
    return true;
  } else {
    return false;
  }
}
const changeProgressMsg = function (message) {
  var progressBarMsg = document.querySelector(".eg-progress-section .eg-para");
  progressBarMsg.innerHTML = message;
};
function addAjaxRequest(deferreds, id, qty, url) {
  const formData = {
    id: `${id}`,
    quantity: qty,
    properties:{
      _isGift:1
    }
  };
  const request = $.ajax({
    url: url,
    type: "POST", // Equivalent to 'method' in fetch
    dataType: "json", // Equivalent to 'headers' in fetch
    data: formData,
  });
  deferreds.push(request);
  return deferreds;
}
let isConfitthre1 = false;
const updateProgessbar = async function () {
  if ($("body.new-cart .eg-progress-section").length > 0) {
    const response = await fetch("/cart.js");
    const data = await response.json();
    if (data.items.length > 0) {
      /*var requestUrl = `https://sweetplaid.com/?section_id=progress-bar-ajax`;
      var request = new XMLHttpRequest();
      request.open("GET", requestUrl);
      request.onload = function () {
        if (request.status >= 200 && request.status < 300) {
          $(".element-progress-bar-placement").html(
            $(request.response).find(".custom-progress-ajax-html").html()
          );
           updateHtmlProgess(data);
        }
      };
      request.send();*/
       updateHtmlProgess(data);
     
    }else{
      $(".element-progress-bar-placement").html("");
       displayCartActionButtons();
    }
  }
};

/*function calculatePercentage(amount, threshold1, threshold2, threshold3) {
  let percentage = 0;

  if (amount <= threshold1) {
    // First range
    percentage = ((amount / (threshold2 + threshold1)) * 100) + 5;
  } else if (amount > threshold1 && amount < threshold2) {
    // Second range
    percentage = ((amount - threshold1) / (threshold2 - threshold1)) * 13.82 + 48.82;
    // Ensure the percentage is within the desired range
    percentage = Math.min(Math.max(48.82, percentage), 61.82);
  } else if (amount >= threshold2 && amount < threshold3) {
    // Third range
    percentage = ((amount - threshold2) / (threshold3 - threshold2)) * 20 + 72;
    // Ensure the percentage is at least 72
    //percentage = Math.max(72, percentage);
     percentage = Math.min(Math.max(72, percentage), 87);
  } else if (amount >= threshold3) {
    // Fourth range
    percentage = 100;
  }

  return percentage;
}*/
function calculatePercentage(amount, threshold1, threshold2, threshold3) {
    let percentage = 0;

    if (amount <= threshold1) {
        percentage = (amount / threshold1) * 42;
    } else if (amount > threshold1 && amount <= threshold2) {
        percentage = 48.82 + ((((amount - threshold1) / (threshold2 - threshold1)) * 20)-3);
        percentage = Math.min(Math.max(48.82, percentage), 61.82);
    } else if (amount > threshold2 && amount <= threshold3) {
        percentage = 72 + ((((amount - threshold2) / (threshold3 - threshold2)) * 20)- 3);
       percentage = Math.min(Math.max(72, percentage), 87);
    } else if (amount > threshold3) {
        percentage = 100;
    }

    return percentage;
}

const updateHtmlProgess = async function (data) {
  
  let cartTotalinCent = data.total_price;
  const mainElement = $(".eg-progress-section");
  const threshold1 = +mainElement.data("threshold");
  const threshold2 = +mainElement.data("threshold2");
  const threshold3 = +mainElement.data("threshold3");
  const gift1Product = mainElement.data("tid");
  const gift2Product = mainElement.data("t2id");
  const gift1ProductPriceInCent = mainElement.data("t1price");
  const gift2ProductPriceInCent = mainElement.data("t2price");
  const defaultMessageString = mainElement.data('defaultmsg');
  const t1msg = mainElement.data('t1msg');
  const t2msg = mainElement.data('t2msg');
  const t3msg = mainElement.data('t3msg');
  const successmsg = mainElement.data("successmsg");
  let isgift1Added = false;
  let isGift2Added = false;
  isgift1Added = await checkGiftAdded(data.items, gift1Product);
  isGift2Added = await checkGiftAdded(data.items, gift2Product);
  /*if(cartTotalinCent <= 0){
    document.querySelectorAll('[name="checkout"]').forEach(elem => {
  elem.disabled = true;
});
  }else{
    document.querySelectorAll('[name="checkout"]').forEach(elem => {
  elem.disabled = false;
});
  }*/
 /* if (isgift1Added) {
    cartTotalinCent = cartTotalinCent - gift1ProductPriceInCent;
  }
  if (isGift2Added) {
    cartTotalinCent = cartTotalinCent - gift2ProductPriceInCent;
  }*/
  let amount = cartTotalinCent / 100;
  console.log(amount, "amount");
  //calculatePercentage(cart.total_price);
  var progressBar = document.querySelector("#eg-bar");
  var percentageChunk = 10;
  var progressBarMsg = document.querySelector(".eg-progress-section .eg-para");
  if (progressBarMsg) {
    let percentage = (amount / threshold3) * 100;
    
    var maxAmount = threshold1;
    var offereteMsg = t1msg;
    if (amount <= threshold1) {
      maxAmount = threshold1;
    } else if (amount > threshold1 && amount <= threshold2) {
      maxAmount = threshold2;
    } else if (amount > threshold2 && amount <= threshold3) {
      maxAmount = threshold3;
    }

    if(amount > threshold1 &&  amount < threshold2){
      offereteMsg = t2msg;
    }else if(amount > threshold2 &&  amount < threshold3){
      offereteMsg = t3msg;
    }
    /*if(amount <= threshold1){
      percentage = ((amount / (threshold2+threshold1)) * 100)+5;
    }else if(amount > threshold1 && amount < threshold2 ){
      percentage = ((amount / (threshold2)) * 100);
      if(percentage < 48.82){
        percentage = 48.82;
      }
      if(percentage > 61.82){
        percentage = 61.82
      }
    }else if(amount > threshold2 && amount < threshold3 ){
      percentage = ((amount / threshold3) * 100);
      if(percentage < 72){
        percentage = 72;
      }
    }else if(amount > threshold3){
      percentage = 100;
    }*/
    percentage = calculatePercentage(amount,threshold1,threshold2,threshold3);
    /*
    if (amount > threshold1 && amount < threshold1 + 1) {
      percentage = 40;
    }else if (amount >= threshold2 && amount < threshold2 + 1) {
      percentage = 64;
    }else if (amount >= threshold3) {
      percentage = 88;
    }
    
  
    // increase chunk size
    if (amount > 50 && amount < 68) {
      percentageChunk = 0;
      percentage = 48.8267;
    }
    if (amount > 80) {
      percentageChunk = -12;
    }
    if (amount > 120) {
      percentageChunk = -45;
    }
    if (amount > 149.99) {
      percentageChunk = 0;
    }
    if (amount >= 91 && amount < 100) {
      percentage = 60.66;
      percentageChunk = 0;
    }
    if (amount >= 128 && amount < 150) {
      percentage = 85;
      percentageChunk = 0;
    }*/

    // conditions for free products
    // add FiftyStagePd
    let deferreds = [];
    if (amount >= threshold2 && isgift1Added == false) {
      if(gift1Product != ""){
         deferreds = addAjaxRequest(deferreds, gift1Product, 1, "/cart/add.js");
      }
     
    }
    // add OneFiftyStagePd
    if (amount > threshold3 && isGift2Added == false) {
       if(gift2Product != ""){
          deferreds = addAjaxRequest(deferreds, gift2Product, 1, "/cart/add.js");
       }
    }
    let needtoRemoves = [];
    // remove OneFiftyStagePd
    if (amount < threshold3 && isGift2Added == true) {
      deferreds = addAjaxRequest(deferreds, gift2Product, 0, "/cart/change.js");
    }
    // remove FiftyStagePd
    if (amount < threshold2 && isgift1Added == true) {
      deferreds = addAjaxRequest(deferreds, gift1Product, 0, "/cart/change.js");
    }

    var remainAmount = Math.abs(maxAmount - amount);
    var remainAmountinFormat = slate.Currency.formatMoney(
      remainAmount * 100,
      theme.moneyFormat
    );
    if (amount < maxAmount) {
      const convertedMessage = defaultMessageString.replace("__AMOUNT__",remainAmountinFormat);
      var updateProgressMsg =`${convertedMessage} ${offereteMsg}`;
      changeProgressMsg(updateProgressMsg);
      /*progressBar.style.cssText =
        "width:calc(" + percentage + "% + " + percentageChunk + "px)";*/
        progressBar.style.width = `${percentage}%`;
        //progressBar.style.cssText ="width:calc(" + percentage + "%)";
      
      if (
        amount > threshold1 &&
        amount < threshold2 &&
        isConfitthre1 == false
      ) {
        var el = document.querySelector(
          "html body .eg-checkpoint-1 .eg-checkpoint-img"
        );
        if (el) {
          progressConfetti(el);
        }
         isConfitthre1 = true;
      }
      if (amount > threshold2 && amount < threshold3 && isgift1Added == false) {
        var el = document.querySelector(
          "html body .eg-checkpoint-2 .eg-checkpoint-img"
        );
        if (el) {
          progressConfetti(el);
        }
      }
      console.log(amount >= threshold3 && isGift2Added == false,"tttt3");
      if (amount >= threshold3 && isGift2Added == false) {
        var el = document.querySelector(
          "html body .eg-checkpoint-3 .eg-checkpoint-img"
        );
        if (el) {
          progressConfetti(el);
        }
      }
    } else {
      progressBar.style.width = "" + 100 + "%";
      var updateProgressMsg = successmsg;
      changeProgressMsg(updateProgressMsg);
      if (amount >= threshold3 && isGift2Added == false) {
        var el = document.querySelector(
          "html body .eg-checkpoint-3 .eg-checkpoint-img"
        );
        if (el) {
          progressConfetti(el);
        }
      }
    }
    if (deferreds.length > 0) {
       hideCartActionButtons();
      $.when.apply($, deferreds).always(function () {
        $.ajax({
          type: "GET",
          url: "/cart",
          dataType: "html",
          success: function (response) {
            
            $("#cartForm").load(" #cartForm");
             if(window.location.pathname == '/cart'){
                $(".cvv_header_cart_outer").html($(response).find(".cvv_header_cart_outer").html());
               $(".cart_drawer").html($(response).filter(".cart_drawer").html());
             }else{
               $(".cvv_header_cart_outer").html(
                  $(response).find(".cvv_header_cart_outer").html()
                );
                $(".cart_drawer")
                  .html($(response).filter(".cart_drawer").html())
                  .addClass("cart_drawer_open");
                $("body").addClass("drawer_open");
              
             }
            
            updateProgessbar();
            loadProductRecommendationsIntoSectionCart();
            setTimeout(function () {
              var fiveMinutes = 60 * 10,
                display = document.querySelector("#time");

              if (window.startTimer) {
                if (window.existingIntervalId) {
                  clearInterval(window.existingIntervalId);
                }
                window.startTimer(fiveMinutes, display);
              }
            }, 1000);
            if(window.location.pathname == '/cart'){
              $.ajax({
                type: 'GET',
                url: '/cart?view=ajax',
                success: function(data){
                  var toReplace = ['.cart-items', '.cart-subtotal-and-discounts'];
                  var $newDom = $('<div>' + data + '</div>');
                  $newDom.find('.fade-in').removeClass('fade-in');
    
                  for(var i = 0; i < toReplace.length; i++) {
                    $('[data-section-type="cart-template"] ' + toReplace[i]).html(
                      $newDom.find(toReplace[i]).html()
                    );
                  }
                  theme.checkCurrency();
                }
              });
            }
            displayCartActionButtons();
          }
        });
      });
    }else{
      displayCartActionButtons();
    }
  }
};
const addToCart = function (upsellID) {
  $.ajax({
    url: "/cart/add.js",
    type: "POST",
    dataType: "JSON",
    data: {
      id: upsellID,
      quantity: 1,
    },
    success: function (response) {
      $.ajax({
        type: "GET",
        url: "/cart",
        dataType: "html",
        success: function (response) {
          $("#cartForm").load(" #cartForm");
          $(".cvv_header_cart_outer").html(
            $(response).find(".cvv_header_cart_outer").html()
          );
          $(".cart_drawer")
            .html($(response).filter(".cart_drawer").html())
            .addClass("cart_drawer_open");
          $("body").addClass("drawer_open");
          updateProgessbar();
          loadProductRecommendationsIntoSectionCart();
          setTimeout(function () {
            var fiveMinutes = 60 * 10,
              display = document.querySelector("#time");

            if (window.startTimer) {
              if (window.existingIntervalId) {
                clearInterval(window.existingIntervalId);
              }
              window.startTimer(fiveMinutes, display);
            }
          }, 1000);
        },
      });
    },
  });
};
var progressConfetti = function (el) {
  var canvas = document.createElement("canvas");
  var container = el;
  canvas.width = 600;
  canvas.height = 600;
  container.appendChild(canvas);
  var confetti_button = confetti.create(canvas);
  confetti_button({
    particleCount: 200,
    spread: 200,
    startVelocity: 15,
    scalar: 0.9,
    ticks: 90,
  });
  confetti_button().then(function () {
    container.removeChild(canvas);
  });
};

const loadProductRecommendationsIntoSectionCart = async function () {
  if ($("body.new-cart .custom-upsell-wrapper").length > 0) {
    if($(".custom-upsell-wrapper .eg-crossSell_items li").length > 0){
      $("body.new-cart .custom-upsell-wrapper").show();
        slickItems();
    }else{
       $("body.new-cart .custom-upsell-wrapper").hide();
    }
    /*const response = await fetch("/cart.js");
    const data = await response.json();
    if (data.items.length > 0) {
      var requestUrl = `https://sweetplaid.com/recommendations/products?section_id=upsell-cart&limit=3&product_id=${data.items[0].product_id}`;
      var request = new XMLHttpRequest();
      request.open("GET", requestUrl);
      request.onload = function () {
        if (request.status >= 200 && request.status < 300) {
          $(".custom-upsell-wrapper").html(
            $(request.response).find(".cart-recom-upsell").html()
          );
          slickItems();
        }
      };
      request.send();
    } else {
      $(".custom-upsell-wrapper").html("");
    }*/
    
  }
};

var slickItems = function () {
  
  if (
    document.querySelector(
      ".eg-crossSell_items:not(.slick-slider):not(.slick-initialized) .eg-crossSell_item"
    )
  ) {
    $(".eg-crossSell_items:not(.slick-slider):not(.slick-initialized)").slick({
      dots: false,
      arrows: true,
      infinite: false,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
    });
  }
};

//}

async function checkFreeitemonCart(){
 
  if($(".eg-progress-section").length > 0){
    const response = await fetch("/cart.js");
    const data = await response.json();
    let threshold1 = $(".eg-progress-section").data('threshold');
    let threshold2 = $(".eg-progress-section").data('threshold2');
    let threshold3 = $(".eg-progress-section").data('threshold3');
    let gift1 = $(".eg-progress-section").data("tid");
    let gift2 = $(".eg-progress-section").data("t2id");
    if (data.items.length > 0) {
       let isgift1Added = false;
        let isGift2Added = false;
        isgift1Added = await checkGiftAdded(data.items, gift1);
        isGift2Added = await checkGiftAdded(data.items, gift2);
      if(data.total_price <= 0){
         const clearCartResponse = await fetch("/cart/clear.js");
        if(window.location.pathname == '/cart'){
          window.location.reload(true);
        }
      }else{
        let amountinCent = threshold2*100;
         let amountinCent2 = threshold3*100;
         let deferreds = [];
          if(data.total_price < amountinCent){
           
            if (isgift1Added == true) {
              deferreds = addAjaxRequest(deferreds, gift1, 0, "/cart/change.js");
            }
            if (isGift2Added == true) {
              deferreds = addAjaxRequest(deferreds, gift2, 0, "/cart/change.js");
            }
          }else if(data.total_price < amountinCent2){
            if (isGift2Added == true) {
              deferreds = addAjaxRequest(deferreds, gift2, 0, "/cart/change.js");
            }
          }
        if(deferreds.length > 0){
           $.when.apply($, deferreds).always(function () {
             window.location.reload(true);
           });
        }
      }
    }
  }
  
}

jQuery(document).ready(function(){
    if(window.location.pathname == '/cart'){
      checkFreeitemonCart();
    }
});

function hideCartActionButtons(){
  document.querySelectorAll('[name="checkout"]').forEach(elem => {
    elem.disabled = true;
    elem.classList.add("hide");
  });
}
function displayCartActionButtons(){
  document.querySelectorAll('[name="checkout"]').forEach(elem => {
    elem.disabled = false;
    elem.classList.remove("hide");
  });
}
if(window.location.pathname == '/cart'){
  hideCartActionButtons();
  window.onload = (event) => {
    displayCartActionButtons();
  };
}
 window.addEventListener("beforeunload", (event) => {
  hideCartActionButtons();
});
window.addEventListener("unload", (event) => {
  hideCartActionButtons();
});